export interface DecodedJWT {
  header: any;
  payload: any;
  signature: string;
}

// Função auxiliar para decodificar Base64URL de forma segura
function decodeBase64Url(str: string): string | null {
  // Substitui caracteres não-alfabéticos da Base64URL e adiciona padding se necessário
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.length % 4 === 0 ? base64 : base64 + '==='.slice(0, 4 - (base64.length % 4));

  try {
    // atob decodifica a string Base64.
    // decodeURIComponent para lidar com caracteres UTF-8.
    return decodeURIComponent(
        atob(padded)
            .split('') // Divide a string em um array de caracteres
            .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0')) // Converte cada caractere para seu percent-encoding
            .join('') // Junta de volta em uma string
    );
  } catch (err) {
    console.error("[decodeBase64Url] Erro ao decodificar Base64URL:", err);
    return null; // Retorna null em caso de erro na decodificação Base64
  }
}

export function decodeJWT(token: string): DecodedJWT | null {
  // Verifica o formato básico do JWT (3 partes separadas por ponto)
  const parts = token.split('.');
  if (parts.length !== 3) {
    console.warn("[decodeJWT] Formato JWT inválido: Esperado 3 partes, encontrou", parts.length);
    return null; // Retorna null se o formato básico estiver errado
  }

  const [headerB64, payloadB64, signatureB64] = parts;

  try {
    // Decodifica e parseia o cabeçalho
    const headerJson = decodeBase64Url(headerB64);
    if (!headerJson) {
      console.warn("[decodeJWT] Falha ao decodificar o cabeçalho Base64URL.");
      return null;
    }
    const header = JSON.parse(headerJson); // Pode lançar erro se não for JSON válido

    // Decodifica e parseia o payload
    const payloadJson = decodeBase64Url(payloadB64);
    if (!payloadJson) {
      console.warn("[decodeJWT] Falha ao decodificar o payload Base64URL.");
      return null;
    }
    const payload = JSON.parse(payloadJson); // Pode lançar erro se não for JSON válido

    // Retorna o objeto JWT decodificado
    return {
      header,
      payload,
      signature: signatureB64,
    };
  } catch (e: any) {
    // Captura erros de JSON.parse ou outros erros inesperados durante o processo
    console.error("[decodeJWT] Erro ao decodificar ou parsear JWT:", e.message || e);
    return null; // Retorna null em caso de qualquer erro no processo de decodificação/parsing
  }
}